import { makeStyles } from '@material-ui/core/styles';

import { toolbarMinHeight } from '../../../service/constants';

const useStyles = makeStyles((theme) => {
    return {
        disabledIcon: {
            opacity: 0.5,
        },
        stepper: {
            display: 'flex',
            justifyContent: 'space-around',
            padding: theme.spacing(0, 2),
            alignItems: 'stretch',
            flexGrow: 1,
            height: 56,
        },
        stepperWrapper: {
            position: 'fixed',
            display: 'flex',
            width: '100%',
            paddingLeft: theme.spacing(7),
            margin: '0 auto',
            flexDirection: 'row',
            placeContent: 'center',
            alignItems: 'center',
            top: toolbarMinHeight,
            zIndex: 11,
            boxShadow: theme.shadows[1],
        },
    };
});

export { useStyles };
